import FieldPairComponent from "./FieldPairComponent";

const MediaViewComponent = ({ data, children }) => {
  return (
    <div>
      <FieldPairComponent label="Title">
        <span className="field-value">{data?.title}</span>
      </FieldPairComponent>

      <FieldPairComponent label="Thumbnail">
        <img
          className="field-value"
          src={data?.thumbnail}
          alt={data?.title}
          height={120}
          width={180}
        />
      </FieldPairComponent>

      {children}
    </div>
  );
};

export default MediaViewComponent;
